import { render } from "./ComponentInput.vue?vue&type=template&id=2fb53cb2&scoped=true"
import script from "./ComponentInput.vue?vue&type=script&lang=js"
export * from "./ComponentInput.vue?vue&type=script&lang=js"

import "./ComponentInput.vue?vue&type=style&index=0&id=2fb53cb2&lang=scss&scoped=true"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fb53cb2"]])

export default __exports__